import { AttachmentSlot, FireMode } from "../../../api/types";
import type { BarValues } from "./statPreview";

/** The six catalog bars in display order. */
export const BAR_ROWS: readonly { key: keyof BarValues; label: string }[] = [
  { key: "damage", label: "Damage" },
  { key: "fireRate", label: "Fire rate" },
  { key: "range", label: "Range" },
  { key: "accuracy", label: "Accuracy" },
  { key: "mobility", label: "Mobility" },
  { key: "control", label: "Control" },
];

export const FIRE_MODE_LABEL: Readonly<Record<FireMode, string>> = {
  [FireMode.AUTO]: "Auto",
  [FireMode.SEMI]: "Semi",
  [FireMode.BURST]: "Burst",
  [FireMode.PUMP]: "Pump",
  [FireMode.BOLT]: "Bolt",
  [FireMode.MELEE]: "Melee",
};

/** Attachment slots in display order. */
export const ATTACHMENT_SLOTS: readonly AttachmentSlot[] = [
  AttachmentSlot.OPTIC,
  AttachmentSlot.MUZZLE,
  AttachmentSlot.BARREL,
  AttachmentSlot.MAGAZINE,
  AttachmentSlot.GRIP,
];

export const ATTACHMENT_SLOT_LABEL: Readonly<Record<AttachmentSlot, string>> = {
  [AttachmentSlot.OPTIC]: "Optic",
  [AttachmentSlot.MUZZLE]: "Muzzle",
  [AttachmentSlot.BARREL]: "Barrel",
  [AttachmentSlot.MAGAZINE]: "Magazine",
  [AttachmentSlot.GRIP]: "Grip",
};
